module.exports = __webpack_public_path__ + "img/icon-unmute.73aa855e.svg";